import React, { useState } from 'react';
import { DASHBOARD_LINK, LOGIN_LINK } from '../../constants/constants'
import WpAPI from '../../WpApi'
import { Redirect } from 'react-router';
const ForgetForm = (props) => {
    const [msg, setMsg] = useState(null)
    const [email, setemail] = useState('')
    const [redirect, setRedirect] = useState(false)
    const [waiting, setWaiting] = useState(false)
    const submitForm = () => {
        setWaiting(true)
        WpAPI.resetPassword(email).then((res) => {
            setMsg({success: 'Please check your email for a password reset link', error: ''})
            setWaiting(false)
        }).catch((e) => {
            setMsg({success: '', error: e})
            setWaiting(false)
        })
    }

    const enter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            submitForm();
        }
    }

    if(WpAPI.isLoggedIn()) return <Redirect to={DASHBOARD_LINK} />

    if (redirect) return <Redirect to={LOGIN_LINK} />
    
    return (
        <div className="login-form forget-form" style={{minHeight: props?.pagetype == 'coverletter' ? 'auto' : ''}}>
            <div className="form">
                <div className="forget-heading"><span className="title">Reset Your Password</span></div>
                {msg && 
                    <div className={`${msg?.success != '' ? 'success' : 'error'}`}>
                        {msg?.success != '' ? msg?.success : msg?.error}
                    </div>
                }
                <div className="field-wrap">
                    <label htmlFor="Email" className="label">Email</label>
                    <input
                        type="email"
                        placeholder="Email Address"
                        value={email} onChange={e => setemail(e.target.value)}
                        className="form-input borderaccent"
                        onKeyDown={e => enter(e)}
                    />
                </div>
                <div className="field-wrap align-center">
                    <button 
                        className={`button ${waiting ? 'blue' : 'black'}`}
                        onClick={() => submitForm()}
                    >
                        {waiting ? 'Please wait...' : 'Reset Password'}
                    </button>
                </div>
                { props?.pagetype !== 'coverletter' && <div className="login-link" onClick={() => setRedirect(true)}>Go to Log In</div> }
            </div>
        </div>
    );
}

export default ForgetForm;